import { getNotificationState } from 'common/header/notifications/hooks/mappers/impl/shared';
import { type NotificationMapper } from 'common/header/notifications/Notifications.types';

export const taskResolvedMapper: NotificationMapper = (notification, options) => {
  const { isReady } = getNotificationState(notification.status);
  return {
    ...notification,
    title: options.intl.taskResolvedTitle,
    description: options.intl.taskResolvedDescription,
    to: isReady ? `/${options.tenantCode}/tasks/edit/${notification.resourceUid}` : undefined
  };
};
